import { useApi } from "shared/services/api/useApi";
import { useCallback } from "react";
import { useQuery } from "react-query";

export const useNavigationLinks = (userId, departmentId) => {

    const { getDataAsync } = useApi();

    const getNavigation = useCallback(async () => {

        const payload = await getDataAsync("navigationModules", {
            params: { userId, departmentId: departmentId },
        });

        return await payload.json();

    }, [getDataAsync, userId, departmentId]);

    const { data: nav = [], isLoading: loading } = useQuery({
        queryKey: ["navigationLinks", userId, departmentId],
        queryFn: getNavigation,
    });

    return { nav, loading };
};
